export enum ProjectActivitiesHeaders{
    ProjectActivities='Project Activities',
    MyActivities='My Activities',
    InvestorActivities='Investor Activities'
  }